"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescriptionTitle = void 0;
const styles_1 = require("@mui/material/styles");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
exports.DescriptionTitle = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    fontWeight: "bold",
    marginBottom: "16px",
    color: theme.palette.institutional.braskemGray,
}));
